/**
 * WebAuthn 사용자 취소/거부 판별.
 *
 * 패스키 프롬프트를 사용자가 닫거나(예: "다른 기기로 등록" QR창 닫기), 거부하거나,
 * 타임아웃되면 브라우저는 모두 `NotAllowedError`(또는 `AbortError`)로 reject한다.
 * 이건 앱 버그가 아니라 사용자/환경 사유이므로 Sentry로 보고하면 노이즈가 된다.
 *
 * features/auth 의 패스키 훅들(usePasskeys)은 이 원본 에러를 사람이 읽을 한국어 메시지로
 * 감싸서(`new Error('인증이 거부되었거나...', { cause: 원본 })`) 다시 throw 한다 — 따라서
 * 래핑된 에러의 `.name` 은 'Error' 다. 취소를 잡으려면 name 단독이 아니라 메시지 +
 * cause 체인을 함께 봐야 한다.
 */

const CANCEL_ERROR_NAMES = new Set(['NotAllowedError', 'AbortError']);

// features/auth 패스키 훅들이 NotAllowedError 를 감쌀 때 쓰는 한국어 메시지 마커.
// (등록 취소 / 명시적 취소 / 로그인 시 미등록)
const CANCEL_MESSAGE_MARKERS = [
  '인증이 거부되었거나 시간이 초과',
  '패스키 등록이 취소',
  '패스키가 등록되어 있지 않습니다',
];

const MAX_CAUSE_DEPTH = 5;

export function isWebAuthnCancelError(error: unknown, depth = 0): boolean {
  if (!(error instanceof Error)) return false;

  if (CANCEL_ERROR_NAMES.has(error.name)) return true;
  if (CANCEL_MESSAGE_MARKERS.some((marker) => error.message.includes(marker))) return true;

  if (depth < MAX_CAUSE_DEPTH && error.cause !== undefined && error.cause !== null) {
    return isWebAuthnCancelError(error.cause, depth + 1);
  }

  return false;
}
